import { env } from "./env";

import { MainUtilInterface } from "components/MainUtil/MainUtil";

import AiHelperPicture from "assets/ai-helper-picture.png";
import LabelingPicture from "assets/labeling-picture.png";
import OdmPicture from "assets/odm-picture.png";
import WikiPicture from "assets/wiki-picture.png";
import MineDetectionPicture from "assets/mine-detection-picture.png";
import BEAdminPanelPicture from "assets/be-admin-picture.png";

import CheckCheckIcon from "assets/icons/check-check.svg";
import AlertTriangleIcon from "assets/icons/alert-triangle.svg";
import LoaderOrangeIcon from "assets/icons/loader-orange.svg";
import LoaderGreyIcon from "assets/icons/loader-grey.svg";
import BanRedIcon from "assets/icons/ban-red.svg";

export const AUTH_URL = env.REACT_APP_AUTH_URL;
export const GEO_VISION_API_URL = env.REACT_APP_GEO_VISION_API_URL;
export const ODM_API_URL = env.REACT_APP_ODM_API_URL;
export const MISSION_PLANNER_API_URL = env.REACT_APP_MISSION_PLANNER_API_URL;
export const PDF_API_URL = env.REACT_APP_PDF_API_URL;
export const EXTERNAL_API_URL = env.REACT_APP_EXTERNAL_API_URL;
export const INFERENCE_API_URL = env.REACT_APP_INFERENCE_API_URL;
export const WIKI_API_URL = env.REACT_APP_WIKI_API_URL;
export const PRIVATE_KEY = env.REACT_APP_PRIVATE_KEY;
export const STORAGE_URL = env.REACT_APP_STORAGE_URL;

export const UNITS_LIMIT = 10;

//DELETE
export const AREA_COLORS = [
  {
    name: "Medium Hazard",
    color: "rgba(255, 122, 0, 0.8)",
    alias: "medium",
    isActive: false,
    radius: 1.5
  },
  {
    name: "Hard Hazard",
    color: "rgba(255, 0, 0, 0.8)",
    alias: "hard",
    isActive: false,
    radius: 1.5
  }
];

const ODM_LINK = env.REACT_APP_ODM_LINK;
const CVAT_LINK = env.REACT_APP_CVAT_LINK;
// const AI_HELPER_LINK = env.REACT_APP_AI_HELPER_LINK;
const BE_ADMIN_PANEL_LINK = "https://blue-eyes-admin.vision.dropla.tech/";
const ML_ADMIN_PANEL_LINK = "https://ml-admin.vision.dropla.tech/";

export const WIKI_LINK = env.REACT_APP_WIKI_LINK;

export enum UserPolices {
  // Generate organization department share token
  SHARE_TOKEN_GENERATION = "aodst",

  // Project operations (GeoCore)
  PROJECT_LIST = "gcpjl",
  PROJECT_CREATE = "gcpjc",
  PROJECT_READ = "gcpjr",
  PROJECT_UPDATE = "gcpju",
  PROJECT_DELETE = "gcpjd",
  PROJECT_REPORT = "gcpjrp",

  // Layer provider operations(GeoCore)
  PROJECT_PROVIDER_CREATE = "gcpjlprc",
  PROJECT_PROVIDER_UPDATE = "gcpjlpru",
  PROJECT_PROVIDER_DELETE = "gcpjlprd",
  PROJECT_PROVIDER_REORDER = "gcpjlprro",

  // Layer unit create operations(GeoCore)"
  PROJECT_PROVIDER_UNIT_ALL_DELETE = "gcpjluda",
  PROJECT_PROVIDER_UNIT_LIST = "gcpjlul",
  PROJECT_PROVIDER_UNIT_CREATE = "gcpjluc",
  PROJECT_PROVIDER_UNIT_READ = "gcpjlur",
  PROJECT_PROVIDER_UNIT_UPDATE = "gcpjluu",
  PROJECT_PROVIDER_UNIT_DELETE = "gcpjlud",
  PROJECT_PROVIDER_UNIT_IMAGE_CREATE = "gcpjluic",

  //Wiki
  WIKI = "wiki_general",
  //Inference
  INFERENCE_GENERAL = "inference_general"
}

export const UTILS_LIST: Array<MainUtilInterface> = [
  {
    policyId: UserPolices.INFERENCE_GENERAL,
    title: "ODM",
    icon: OdmPicture,
    link: ODM_LINK,
    target: "_blank"
  },
  {
    policyId: "labeling_general",
    title: "Labeling tool",
    icon: LabelingPicture,
    link: CVAT_LINK,
    target: "_blank"
  },
  {
    policyId: "labeling_general",
    title: "ML Admin",
    icon: AiHelperPicture,
    link: ML_ADMIN_PANEL_LINK,
    target: "_blank"
  },
  {
    policyId: UserPolices.WIKI,
    title: "Wiki mine",
    icon: WikiPicture,
    link: WIKI_LINK,
    target: "_blank"
  },
  {
    policyId: "inference_general", //TODO: change policyId when it is available
    title: "Mine detection",
    icon: MineDetectionPicture,
    link: "/image-detection"
  },
  {
    policyId: "be_admin",
    title: "Admin panel Blue Eyes",
    icon: BEAdminPanelPicture,
    link: BE_ADMIN_PANEL_LINK,
    target: "_blank"
  }
];

export const KYIV_COORDINATES = { lat: 50.450001, lng: 30.523333 };

export enum MapToolsModes {
  LAYERS = "Layers",
  ROUTES = "Routes"
}

export const mapToolsList: MapToolsModes[] = Object.values(MapToolsModes);

export enum OperationModes {
  GRASSCUTTERS = "Grasscutters",
  HAMMERS = "Hammers"
}
export const operationModesList: OperationModes[] =
  Object.values(OperationModes);

export enum MapModes {
  DEFAULT = "default",
  POLYGON_CREATION = "polygon_creation",
  LABEL_POINT_POLYGON_CREATION = "label_point_polygon_creation",
  MISSION_POLYGON_CREATION = "mission_polygon_creation",
  MISSION_VEHICLE_POINT_CREATION = "mission_vehicle_point_creation",
  SEARCH_POINT = "search_point"
}

export enum LayerAlias {
  RGB = "rgb",
  RGB2 = "rgb2",
  MULTISPECTRAL = "multispectral",
  THERMAL = "thermal",
  MAGNETIC = "magnetic",
  SENSOR_FUSION = "sensor-fusion",
  MANUAL = "manual"
}

export interface LayerInterface {
  name: string;
  color?: string;
  alias: LayerAlias;
  isCustom?: boolean;
  isUseFileManager?: boolean;
}

export enum UnitTrainingClassificationTypes {
  TRUE_POSITIVE = "true_positive",
  FALSE_POSITIVE = "false_positive"
}

// export interface UnitTrainingClassifications {
//   name: string;
//   type: UnitTrainingClassificationTypes;
// }

export enum PointClassificationsAliases {
  UXO = "uxo",
  TRASH = "trash",
  NATURAL = "natural",
  UNCLASSIFIED = "unclassified"
}

export const PointClassificationsNames: Record<
  PointClassificationsAliases,
  string
> = {
  [PointClassificationsAliases.UXO]: "UXO",
  [PointClassificationsAliases.TRASH]: "Trash",
  [PointClassificationsAliases.NATURAL]: "Natural object",
  [PointClassificationsAliases.UNCLASSIFIED]: "Unclassified"
};

// export const UNITS_TRAINING_CLASSIFICATIONS: Array<UnitTrainingClassifications> =
//   [
//     {
//       name: "TP",
//       type: UnitTrainingClassificationTypes.TRUE_POSITIVE
//     },
//     {
//       name: "FP",
//       type: UnitTrainingClassificationTypes.FALSE_POSITIVE
//     }
//   ];

export const LAYERS: Record<LayerAlias, LayerInterface> = {
  [LayerAlias.SENSOR_FUSION]: {
    name: "Sensor fusion",
    color: "#391A5F",
    alias: LayerAlias.SENSOR_FUSION
  },
  [LayerAlias.RGB]: {
    name: "RGB",
    color: "#FF0000",
    alias: LayerAlias.RGB
  },
  [LayerAlias.RGB2]: {
    name: "RGB2",
    color: "#FF7A00",
    alias: LayerAlias.RGB2,
    isUseFileManager: true
  },
  [LayerAlias.MULTISPECTRAL]: {
    name: "Multispectral",
    color: "#00CB50",
    alias: LayerAlias.MULTISPECTRAL
  },
  [LayerAlias.THERMAL]: {
    name: "Thermal",
    color: "#00D1FF",
    alias: LayerAlias.THERMAL,
    isUseFileManager: true
  },
  [LayerAlias.MAGNETIC]: {
    name: "Magnetic",
    color: "#EDBEFF",
    alias: LayerAlias.MAGNETIC,
    isUseFileManager: true
  },
  [LayerAlias.MANUAL]: {
    name: "Manual",
    alias: LayerAlias.MANUAL,
    isCustom: true
  }
};

export interface CoordinatesInterface {
  name: string;
  alias: CoordinatesAlias;
}

export enum CoordinatesAlias {
  DD = "dd",
  DMS = "dms",
  UTM = "utm",
  MGRS = "mgrs"
}

export const COORDINATES_SYSTEM: Record<
  CoordinatesAlias,
  CoordinatesInterface
> = {
  [CoordinatesAlias.DD]: {
    name: "WGS 84 DD",
    alias: CoordinatesAlias.DD
  },
  [CoordinatesAlias.DMS]: {
    name: "WGS 84 DMS",
    alias: CoordinatesAlias.DMS
  },
  [CoordinatesAlias.UTM]: {
    name: "UTM",
    alias: CoordinatesAlias.UTM
  },
  [CoordinatesAlias.MGRS]: {
    name: "MGRS",
    alias: CoordinatesAlias.MGRS
  }
};

export const COORDINATES_SYSTEM_ITEMS: CoordinatesInterface[] =
  Object.values(COORDINATES_SYSTEM);

export const DEFAULT_LAYERS_LIST: LayerInterface[] = Object.values(LAYERS);

export enum UnitTypes {
  POINT = "Point",
  POLYGON = "Polygon",
  PHOTO = "Photo"
}

export enum PolygonColors {
  RED = "#FF0000",
  ORANGE = "#FF9800",
  GREEN = "#4CAF50",
  YELLOW = "#FFD900",
  BLUE = "#00E5FF80"
}

export const ACTIVE_MARKER_COLOR = "#09090B";

export interface PointTypeInterface {
  value: string;
  label: string;
  icon: string;
}

export enum InferenceStatus {
  PREPARING = "preparing",
  PREPARED = "prepared",
  PENDING = "pending",
  PROCESSING = "processing",
  STOPPING = "stopping",
  DONE = "done",
  FAILED = "failed",
  STOPPED = "stopped",
  UPLOADING = "uploading"
}
export interface InferenceStatusInterface {
  alias: InferenceStatus;
  label: string;
  icon?: string;
  isIconRotating?: boolean;
}

export const INFERENCE_STATUSES: Record<
  InferenceStatus,
  InferenceStatusInterface
> = {
  [InferenceStatus.DONE]: {
    alias: InferenceStatus.DONE,
    label: "Complete",
    icon: CheckCheckIcon
  },
  [InferenceStatus.FAILED]: {
    alias: InferenceStatus.FAILED,
    label: "Error",
    icon: AlertTriangleIcon
  },
  [InferenceStatus.PREPARING]: {
    alias: InferenceStatus.PREPARING,
    label: "Preparing",
    icon: LoaderOrangeIcon,
    isIconRotating: true
  },
  [InferenceStatus.PREPARED]: {
    alias: InferenceStatus.PREPARED,
    label: "Prepared"
    // icon: LoaderGreyIcon
  },
  [InferenceStatus.PENDING]: {
    alias: InferenceStatus.PENDING,
    label: "In queue",
    icon: LoaderGreyIcon,
    isIconRotating: true
  },
  [InferenceStatus.PROCESSING]: {
    alias: InferenceStatus.PROCESSING,
    label: "In process",
    icon: LoaderGreyIcon,
    isIconRotating: true
  },
  [InferenceStatus.STOPPING]: {
    alias: InferenceStatus.STOPPING,
    label: "Cancellation ...",
    icon: LoaderGreyIcon,
    isIconRotating: true
  },
  [InferenceStatus.STOPPED]: {
    alias: InferenceStatus.STOPPED,
    label: "Inference canceled",
    icon: BanRedIcon
  },
  [InferenceStatus.UPLOADING]: {
    alias: InferenceStatus.UPLOADING,
    label: "Uploading",
    icon: BanRedIcon
  }
};

export const MULTISPECTRAL_FILTERS_OPTIONS = [
  {
    name: "RGB",
    rescalePercents: [4, 100]
  },
  {
    name: "NDVI",
    rescalePercents: [16.91, 90.82]
  },
  {
    name: "vNDVI",
    rescalePercents: [7.89, 81.58]
  },
  {
    name: "EXG",
    rescalePercents: [12.68, 84.51]
  }
];

export const dmsRegex =
  /(\d{1,3})[°d]\s*(\d{1,2})['m]\s*(\d{1,2}(?:\.\d+)?)["s]?\s*([NSEW]?)/i;

export const ddRegex = /^(-?\d+(\.\d+)?)$/;

export const colorOpacityRegex = /^(0|([1-9][0-9]{0,2}))?$/;

export enum UserRoles {
  USER = "user",
  HEAD = "head"
}

export enum VehiclePointType {
  ENTER = "in_point",
  EXIT = "out_point"
}

export const TEXT_RELOAD_DELAY = 5000;
